import {
  Acknowledgements,
  AreasDetailsSummary,
  AttachmentsSummaryReview,
  ContractorDetailsSummary,
  DocumentPreviewDrawer,
  Row,
  RowSize,
  VisitDetailsSummary,
} from "@/components";
import { DrawerParams } from "@/constants/drawer";
import {
  FileDataProps,
  RequestsPayload,
  selectRequestFormStore,
} from "@/services";
import { selectRequestFormData, useBoundStore } from "@/services/stores";
import { getValidDate } from "@/utils/get-valid-date";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./styles.scss";
import { selectActiveApplicationData } from "@/services/stores/selectors/applications";
import { useFormContext } from "react-hook-form";
import { ContractField } from "@/pages/requests/components/contract-details-form/types";
import { useAcknowledgements } from "@/hooks";

export const ReviewRequestForm = () => {
  const { requestFormData } = useBoundStore(selectRequestFormData);

  const { activeApplication } = useBoundStore(selectActiveApplicationData);
  const [searchParams, setSearchParams] = useSearchParams();

  const { getValues } = useFormContext<RequestsPayload>();

  const selectedContract = getValues(ContractField.ContractType);

  const { setIsAcknowledged } = useBoundStore(selectRequestFormStore);

  const { acknowledgements } = useAcknowledgements(
    selectedContract?.Employee?.EmpId,
    activeApplication?.Id,
    activeApplication?.ActionType?.Id,
  );

  useEffect(() => {
    setIsAcknowledged(false);
  }, [acknowledgements, setIsAcknowledged]);

  const from = getValidDate(requestFormData?.From);
  const to = getValidDate(requestFormData?.To);

  const previewDocTypeId = searchParams.get(DrawerParams.DRAWER_DOC_ID);

  const handlePreviewDocument = useCallback(
    (file?: FileDataProps) => {
      setSearchParams({
        [DrawerParams.DRAWER_SEARCH_PARAM]: `${file?.name}`,
        [DrawerParams.DRAWER_DOC_ID]: `${file?.DocTypeId}`,
      });
    },
    [setSearchParams],
  );

  return (
    <>
      <div className={styles.title}>Request summary</div>

      <Row size={RowSize.Large}>
        <ContractorDetailsSummary
          data={{
            CompanyName: requestFormData?.Companies?.CompanyNameEn,
            ContractNo: requestFormData?.ContractType?.ContractNo,
            ContractAdministrator:
              requestFormData?.ContractType?.Employee?.NameEn,
            SubContractor: requestFormData?.SubContractor?.CompanyNameEn,
            Purpose: requestFormData?.Purpose?.PurposeEn,
          }}
        />
      </Row>

      <Row size={RowSize.Large}>
        <VisitDetailsSummary
          data={{
            Purpose_OF_Visit_E: requestFormData?.Purpose?.PurposeEn,
            Start_date: from,
            End_Date: to,
            Number_Of_Persons:
              requestFormData?.Personnels?.length ??
              requestFormData?.NumberOfPersonnel,
            Number_Of_Vehicles: requestFormData?.NumberOfVehicles,
            Number_Of_Camera: requestFormData?.NumberOfCameras,
            Number_Of_Vessles: requestFormData?.NumberOfVessels,
          }}
          isReview
        />
      </Row>

      <Row size={RowSize.Large}>
        <AreasDetailsSummary areas={requestFormData?.Areas} />
      </Row>

      <Row size={RowSize.Large}>
        <AttachmentsSummaryReview onPreviewDocument={handlePreviewDocument} />
      </Row>
      <Row size={RowSize.Large}>
        <Acknowledgements acknowledgements={acknowledgements} />
      </Row>

      <div className={styles.spacer} />

      <DocumentPreviewDrawer
        doc={
          previewDocTypeId
            ? (requestFormData?.RequestDocuments?.[previewDocTypeId].base64 as
                | string
                | null
                | undefined)
            : null
        }
      />
    </>
  );
};
